import { getUserGroup } from "app/services/userGroupService";
import { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";

export default function UserGroupSearch({
  setSelected,
  selected,
  setFieldValue,
  touched,
  errors,
  name,
  value,
}) {
  const [allUerGroup, setAllUerGroup] = useState([]); // Store all countries
  const loadOptions = async (inputValue) => {
    if (!inputValue) return [];

    const response = await getUserGroup(inputValue);
    const userGroups = response.data.data || [];

    return userGroups.map((group) => ({
      label: group.name,
      value: group.id,
    }));
  };

  const handleChange = (selectedOption) => {
    debugger;
    setSelected(selectedOption);
    setFieldValue(name, selectedOption ? selectedOption.value : 0);
  };
  useEffect(() => {
    const fetchGroup = async () => {
      const { data } = await getUserGroup(""); // Fetch all countries at once
      if (data?.data?.length > 0) {
        setAllUerGroup(data.data);
      }
    };

    fetchGroup(); // Call API only once
  }, []);

  // Set selected value when `value` changes
  useEffect(() => {
    if (value && allUerGroup.length > 0) {
      const selected = allUerGroup.find((item) => item.id == value);
      if (selected) {
        setSelected({
          label: selected.name,
          value: selected.id,
        });
        setFieldValue(name, selected ? selected.id : 0);
      }
    }
  }, [value, allUerGroup]);

  return (
    <div>
      <AsyncSelect
        cacheOptions
        defaultOptions
        value={selected}
        loadOptions={loadOptions}
        onChange={handleChange}
        placeholder="Select User Group..."
        name={name}
      />
      {touched[name] && errors[name] && (
        <div className="text-danger">{errors[name]}</div>
      )}
    </div>
  );
}
